var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.14 12.2042C21.14 11.566 21.0827 10.9524 20.9764 10.3633H12.5V13.8446H17.3436C17.135 14.9696 16.5009 15.9228 15.5477 16.561V18.8192H18.4564C20.1582 17.2524 21.14 14.9451 21.14 12.2042Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4997 21.0009C14.9297 21.0009 16.967 20.195 18.4561 18.8205L15.5475 16.5623C14.7416 17.1023 13.7107 17.4214 12.4997 17.4214C10.1557 17.4214 8.17157 15.8382 7.46384 13.7109H4.45703V16.0428C5.93794 18.9841 8.98157 21.0009 12.4997 21.0009Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46408 13.7088C7.28409 13.1688 7.18181 12.592 7.18181 11.9988C7.18181 11.4057 7.28409 10.8288 7.46408 10.2888V7.95703H4.45727C3.84773 9.17203 3.5 10.5466 3.5 11.9988C3.5 13.4511 3.84773 14.8257 4.45727 16.0407L7.46408 13.7088Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4997 6.57954C13.8211 6.57954 15.0075 7.03363 15.9402 7.92545L18.5216 5.34409C16.9629 3.89182 14.9257 3 12.4997 3C8.98157 3 5.93794 5.01682 4.45703 7.95818L7.46384 10.29C8.17157 8.16272 10.1557 6.57954 12.4997 6.57954Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.ee675a2bd5843b815be9d5a887ce561f.svg";
export { ForwardRef as ReactComponent };